import apiClient from './apiClient.js';
import * as utils from '../utils/utils.js';

export const fetchAllEventsByOwner = async (ownerId) => {
    let events_url =
        utils.backendUrl() + '/events_by_owner?owner_id=' + ownerId;

    return handleGetEvents(events_url);
};

export const fetchAllFutureEventsByOwner = async (ownerId) => {
    let events_url =
        utils.backendUrl() + '/future_events_by_owner?owner_id=' + ownerId;

    return handleGetEvents(events_url);
};

export const fetchAllEventsByGathering = async (gatheringId) => {
    let events_url =
        utils.backendUrl() + '/events_by_group?gathering_id=' + gatheringId;

    return handleGetEvents(events_url);
};

export const sendAllEventsByEmail = async (email) => {
    let url = '/events_by_email';

    try {
        const response = await apiClient.post(url, { email: email });

        let status = response.data;

        return status;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const fetchAllEventsByParticipants = async (participantIds) => {
    let events_url = '/events_by_participants';
    try {
        const response = await apiClient.post(events_url, {
            participant_ids: participantIds,
        });

        let events = response.data.events;
        return events;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

const handleGetEvents = async (url, withCredentials) => {
    try {
        const response = await apiClient.get(url);

        let events = response.data.events;

        return events;
    } catch (err) {
        console.error(err);
        throw err;
    }
};
